module.exports = __webpack_public_path__ + "img/cee61d1dcef6df6a4c48ebdf3d1331ec.png";